var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "flex-grid",
        class: _vm.gridClass,
        attrs: { id: _vm.gridId }
      },
      [
        _vm._l(_vm.gridData, function(item, itemIdx) {
          return [
            _c(
              "div",
              { key: _vm.gridId + "-" + itemIdx, staticClass: "item" },
              [
                _c("div", { class: ["panel", "panel-" + _vm.colorVariant] }, [
                  _c("div", { staticClass: "panel-heading" }, [
                    item.END_DATE
                      ? _c(
                          "span",
                          {
                            class:
                              "badge due-" + _vm.getDueStatus(item.END_DATE)
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.classPage.AssignmentCarousel.classPage_due"
                                    )
                                  )
                              )
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(item.END_DATE)) +
                                " \n\t\t\t\t\t\t"
                            )
                          ]
                        )
                      : _c(
                          "span",
                          { staticClass: "badge badge-secondary due-none" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.classPage.AssignmentCarousel.classPage_noDueDate"
                                  )
                                ) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "panel-body text-center",
                      class: "panel-body-" + _vm.gridId
                    },
                    [
                      _c("p", [
                        _c("strong", [_vm._v(_vm._s(item.NAME))]),
                        _c("br"),
                        _vm._v(" "),
                        !!item.COURSE_SECTION_TITLE
                          ? _c("span", [
                              _vm._v(_vm._s(item.COURSE_SECTION_TITLE))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !!item.COURSE_TITLE
                          ? _c("span", [_vm._v(_vm._s(item.COURSE_TITLE))])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        !!item.POINTS
                          ? _c("span", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.classPage.AssignmentCarousel.classPage_pointsWithPoints",
                                      { points: item.POINTS }
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      item.TEST_RID
                        ? _c("span", { staticClass: "text-sm" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.classPage.AssignmentCarousel.classPage_testClosesAt",
                                    { time: _vm.getTime(item.END_DATE) }
                                  )
                                ) +
                                "\n\t\t\t\t\t\t"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.role === "student" &&
                      item.TEST_RID &&
                      item.TEST_ENDED_FLG !== "Y"
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: {
                                click: function($event) {
                                  return _vm.openTest(item)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.AssignmentsCarousel.takeTestText"
                                    )
                                  )
                                )
                              ]),
                              _c("br")
                            ]
                          )
                        : item.GRADING_COMPLETE_FLG === "Y"
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: {
                                click: function($event) {
                                  return _vm.reviewTest(item)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.AssignmentsCarousel.reviewTestText"
                                    )
                                  )
                                )
                              ]),
                              _c("br")
                            ]
                          )
                        : item.DROPBOX_ASSIGNMENT_ID
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: {
                                click: function($event) {
                                  return _vm.openDropboxAssignment(item)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.classPage.AssignmentCarousel.classPage_uploadSubmission"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c("br")
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ]
            )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }